export const OrgUserDetailsTestIds = {
  userDisplayname: 'user_displayname',
  userStatus: 'user_status',
  userDeleteBtn: 'user_delete_btn',
  editDisplaynameBtn: 'user_change_displayname_btn',
  editDisplaynameInput: 'user_changedisplayname_input',
  submitEditDisplaynameBtn: 'user_submit_change_displayname_btn',
  cancelEditDisplaynameBtn: 'user_cancel_change_displayname_btn'
} as const;
